module.exports = __webpack_public_path__ + "static/media/sannsynlighet.0644296b.mp3";